"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101ac806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c8063044609031461005157806308def1621461006f5780634aa83d0e1461008d578063538ba4f9146100ab575b600080fd5b6100596100c9565b60405161006691906100ff565b60405180910390f35b6100776100d0565b60405161008491906100ff565b60405180910390f35b6100956100d9565b6040516100a291906100ff565b60405180910390f35b6100b36100e1565b6040516100c0919061015b565b60405180910390f35b620f424081565b64e8d4a5100081565b633b9aca0081565b600081565b6000819050919050565b6100f9816100e6565b82525050565b600060208201905061011460008301846100f0565b92915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006101458261011a565b9050919050565b6101558161013a565b82525050565b6000602082019050610170600083018461014c565b9291505056fea2646970667358221220933cee776a8da830ebb8646eb6c6a2f86e3899648fa35d0b526518261dd9408f64736f6c634300080f0033";
const isSuperArgs = (xs) => xs.length > 1;
class Constants__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Constants";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Constants__factory = Constants__factory;
Constants__factory.bytecode = _bytecode;
Constants__factory.abi = _abi;
